var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _line, _line2, _circle3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenanceMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324 304",
    width: 324,
    height: 304,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 300,
    height: 276,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#E8E8E8",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 36,
    width: 134,
    height: 96,
    rx: 8,
    fill: "#455A64"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 46,
    width: 114,
    height: 76,
    rx: 4,
    fill: "#ECEFF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 132,
    width: 26,
    height: 16,
    fill: "#455A64"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 146,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#455A64"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 58,
    width: 94,
    height: 10,
    rx: 5,
    fill: "#C91761"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 76,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#B0BEC5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 92,
    width: 78,
    height: 8,
    rx: 4,
    fill: "#B0BEC5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 128,
    r: 40,
    fill: "#C91761"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 128,
    r: 31,
    fill: "#FFFFFF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 128,
    x2: 222,
    y2: 108,
    stroke: "#455A64",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 128,
    x2: 236,
    y2: 137,
    stroke: "#455A64",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 128,
    r: 5,
    fill: "#C91761"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 226,
    textAnchor: "middle",
    fill: "#3A3A3A",
    fontFamily: "'Source Sans Pro', Arial, 'Helvetica Neue', Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 25
  }, "Maintenance Mode")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceMode);
export default __webpack_public_path__ + "static/media/Maintenance-Mode.8e968660f12341ed7493738b87eb90ae.svg";
export { ForwardRef as ReactComponent };